module.exports = __webpack_public_path__ + "9006de6a66ec55ac191005d9fbeeacb7.svg";